import { FormControl, FormField, FormItem } from "@repo/ui";
import type { Control } from "react-hook-form";
import type { Copsoq3Question } from "./copsoq3-pompiers-data";
import { OptionCopsoq3, PastilleOption } from "./copsoq3-option";

interface Copsoq3QuestionProps {
  control: Control<Record<string, string>>;
  question: Copsoq3Question;
  editable: boolean;
}

/** Une question de la partie 2 : une échelle de réponses, une seule retenue.
 * La valeur du champ est l'index de l'option, en chaîne. */
export function Copsoq3QuestionPartie2({
  control,
  question,
  editable,
}: Copsoq3QuestionProps) {
  return (
    <FormField
      control={control}
      name={question.name}
      render={({ field }) => (
        <FormItem className="gap-6">
          <p className="text-xl font-medium leading-relaxed">
            {question.question}
          </p>

          <FormControl>
            <div className="flex flex-col gap-3">
              {question.options.map((option, index) => {
                const selectionne = field.value === index.toString();
                return (
                  <OptionCopsoq3
                    key={index}
                    label={option.label}
                    selectionne={selectionne}
                    disabled={!editable}
                    onClick={() => field.onChange(index.toString())}
                    indicateur={
                      <PastilleOption selectionne={selectionne}>
                        {String.fromCharCode(65 + index)}
                      </PastilleOption>
                    }
                  />
                );
              })}
            </div>
          </FormControl>
        </FormItem>
      )}
    />
  );
}
